import { PropsWithChildren } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { createLoadEnumsAction, hasEnumType } from "@multiweb/reactCore/enums";
import { IAppState } from "@multiweb/types/react";
import { EnumLoaderComponent, EnumLoaderComponentProps } from "./EnumLoaderComponent";

export type EnumLoaderProps = Readonly<PropsWithChildren<{
    /** Typ enumu, který se má nahrát */
    enumName: string;
}>>;

type StateProps = Pick<EnumLoaderComponentProps, "enumLoaded">;
type DispatchProps = Pick<EnumLoaderComponentProps, "loadEnum">;

const mapStateToProps: MapStateToProps<StateProps, EnumLoaderProps, IAppState> = (state, { enumName }) => ({
    enumLoaded: hasEnumType(state, enumName),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, EnumLoaderProps> = (dispatch, { enumName }) => ({
    loadEnum: () => dispatch(createLoadEnumsAction([enumName], true)),
});

/** Postará se o načtení typu enumu, pokud ještě v reduxu neexistuje. */
export const EnumLoader = connect(mapStateToProps, mapDispatchToProps)(EnumLoaderComponent);
